export default __webpack_public_path__ + "static/media/Wizard_Framed.e3376400.png";